// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7iJzz","colMin":"styles_colMin__192C4"};